export const ERROR_TYPE = {
  ZERO_RESULTS: 0,
  NO_DRIVER_TRACKING: 1,
  NO_DELIVERY_POINT_AVAILABLE: 2,
  API_ERROR: 3,
  MAX_ROUTE_LENGTH_EXCEEDED: 4,
};

export const ERROR_DETAIL = {
  zeroResults: {
    message: 'A rota entre os pontos de entrega dessa viagem não pode ser traçada.',
    icon: 'map',
    color: '#FF9800',
  },
  noDriverTracking: {
    message: 'Veículo sem monitoramento em tempo real.',
    icon: 'near_me',
    color: '#FF9800',
  },
  noDeliveryPointAvailable: {
    message: 'Os pontos de entrega dessa viagem não estão disponíveis.',
    icon: 'location_off',
    color: '#FF9800',
  },
  apiError: {
    message: 'A posição do veículo e os pontos de entrega dessa viagem não estão disponíveis.',
    icon: 'error_outline',
    color: '#F44336',
  },
  maxRouteLengthExceeded: {
    message: 'Não foi possível renderizar a rota do motorista.',
    icon: 'location_off',
    color: '#FF9800',
  },
};

export const deliveryStatus = {
  ON_TIME: 1,
  DELAY: 2,
  RISK_OF_DELAY: 3,
};

export const deliveryStatusTranskey = {
  [deliveryStatus.ON_TIME]: 'No prazo',
  [deliveryStatus.DELAY]: 'Atrasado',
  [deliveryStatus.RISK_OF_DELAY]: 'Risco de atraso',
};

export const deliveryStatusColor = {
  [deliveryStatus.ON_TIME]: '#3B873E',
  [deliveryStatus.DELAY]: '#F44336',
  [deliveryStatus.RISK_OF_DELAY]: '#FF9800',
};
